module.exports = __webpack_public_path__ + "static/img/caseContent.b5e643cd.png";